import api from '../../api/index';

const getgricdstore = `${process.env.VUE_APP_BASE_URI}/enterprise/gricd`;

const getDefaultState = () => {
  return {
    gricdStore: [],
    status: '',
  };
};

const state = getDefaultState();

const getters = {
  gricdStore: (state) => state.gricdStore,
};

const actions = {
  async getGricdStore({commit}, pass) {
    commit('getgricdstore_request');
    const res = await api.post(getgricdstore, pass);
    if (res.data.success) {
      commit('getgricdstore_success', res.data.payload);
    }
    return res;
  },
};

const mutations = {
  getgricdstore_request: (state) => (state.status = 'loading'),
  getgricdstore_success: (state, data) => {
    state.status = 'loading';
    state.gricdStore = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
